/* eslint-disable max-len */
// import { thousand } from '../../../utils/format';

export const validate = (values, productGeneralMaxPrice, productGeneralMinPrice) => {
  const errors = {};
  if (values.minPrice < productGeneralMinPrice) {
    errors.minPrice = 'Harga jual mininum tidak sesuai dengan ketentuan';
    // `Harga jual minimum tidak boleh kurang dari Rp ${thousand(productGeneralMinPrice)}`;
  }
  if (values.maxPrice > productGeneralMaxPrice) {
    errors.maxPrice = 'Harga jual maksimum tidak sesuai dengan ketentuan';
    // `Harga Jual Maksimum tidak boleh lebih dari Rp ${thousand(productGeneralMaxPrice)}`;
  }
  if (!values.minPrice) {
    errors.minPrice = { _error: 'Harga Jual Minimum harus diisi' };
  }
  if (!values.maxPrice) {
    errors.maxPrice = { _error: 'Harga Jual Maksimum harus diisi' };
  }

  if (Number(values.minPrice) <= 0) {
    errors.minPrice = 'Harga Jual Minimum harus diatas 0';
  }

  if (Number(values.maxPrice) <= 0) {
    errors.maxPrice = 'Harga Jual Maksimum harus diatas 0';
  }

  if (values.minPrice.toString().length > 6) {
    errors.minPrice = 'Harga Jual Minimum tidak boleh lebih dari 6 digit';
  }
  if (values.maxPrice.toString().length > 6) {
    errors.maxPrice = 'Harga Jual Maksimum tidak boleh lebih dari 6 digit';
  }

  if (Number(values.minPrice) > Number(values.maxPrice)) {
    errors.minPrice = 'harus lebih kecil dari harga maksimum';
    errors.maxPrice = 'harus lebih besar dari harga minimum';
  }
  return errors;
};
